import React from 'react';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import RadioGroup from '../../commonComponents/util/RadioGroup';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import UploadAttachments from '../../commonComponents/shared/UploadAttachments';
import IncompleteApplicationWarning from '../../commonComponents/shared/IncompleteApplicationWarning';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import Select from '../../commonComponents/util/Select';
import AutocompleteInput from '../../commonComponents/util/AutocompleteInput';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import PaymentInfo from '../../applicationsComponents/newApplication/PaymentInfo';
import CheckExistsWarningModal from '../../applicationsComponents/newApplication/CheckExistsWarningModal';
import _cloneDeep from 'lodash.clonedeep';

import { ApplicationStatuses, ManualPaymentTypes } from '../../../lib/systemVariables';
import { SourceTypes } from '../../../lib/constants';
import { deepEquals, concatenateAddressLabel, formatCurrency, formatReferenceOptions, getApplicationPayee, stripCurrencyFormat, formatDate, formatDateForInput } from '../../../lib/utils';
import MarkInquiry from '../../applicationsComponents/applicationsCommon/MarkInquiry';
import MarkInquiryWarning from '../../applicationsComponents/applicationsCommon/MarkInquiryWarning';

export default class ApplicationDetailsEditCard extends NavigationComponent {
    constructor(props) {
        super(props);

        const { applicationDetails } = this.props;

        this.initialState = {
            application: props.getInitialFormattedApplication(applicationDetails),
         
            applicationSourceType: !applicationDetails.source ? SourceTypes.New :
                props.recipientDetails.references.map(r => r.referenceId).indexOf(applicationDetails.source.referenceId) >= 0 ? SourceTypes.Reference : SourceTypes.New,
            thirdPartyPayeeType: applicationDetails.paymentInfo.thirdParty && applicationDetails.paymentInfo.thirdParty.referenceId ? SourceTypes.Reference : SourceTypes.New,
            showCareOf: applicationDetails.paymentInfo.thirdParty && applicationDetails.paymentInfo.thirdParty.careOf ? true : false,

            incomplete: applicationDetails.status === ApplicationStatuses.Incomplete,
            error: false,
            manualCheckError: false,
            manualCheckLabel: applicationDetails.paymentInfo.manualPayment  && applicationDetails.paymentInfo.manualPayment.manualPaymentType === ManualPaymentTypes.BlankCheck ? applicationDetails.paymentInfo.manualPayment.manualPaymentNumber || '' : '',
            submitAttempted: applicationDetails.status === ApplicationStatuses.Incomplete,
            showModals: {
                checkExistsWarningModal: false,
            },
        };
        this.state = _cloneDeep(this.initialState);

        this.onChange = this.onChange.bind(this);
        this.updateApplication = this.updateApplication.bind(this);
        this.updatePaymentInfo = this.updatePaymentInfo.bind(this);
    }

    componentWillMount() {
        if (this.state.application.paymentInfo.fundId && this.state.application.paymentInfo.manualPayment && this.state.application.paymentInfo.manualPayment.manualPaymentType)
            this.props.getBlankChecks(this.state.application.paymentInfo.fundId);
    }

    onChange(name, value) {
        this.setState({ [name]: value });
    }

    eventUpdate(func, event) {
        func(event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value);
    }

    updateApplication(name, value) {
        this.setState({
            application: {
                ...this.state.application,
                [name]: value
            }
        });
    }

    updatePaymentInfo(name, value) {
        if (name === 'fundId' && this.state.application.paymentInfo.manualPayment && this.state.application.paymentInfo.manualPayment.manualPaymentType) {
            this.props.getBlankChecks(value);
            this.setState({
                manualCheckLabel: '',
                application: {
                    ...this.state.application,
                    paymentInfo: {
                        ...this.state.application.paymentInfo,
                        [name]: value,
                        manualPayment: { ...this.state.application.paymentInfo.manualPayment, blankCheckId: '' }
                    }

                }
            });
        } else this.setState({
            application: {
                ...this.state.application,
                paymentInfo: { ...this.state.application.paymentInfo, [name]: value }
            }
        });
    }

    updateAttachments(name, value) {
        this.setState({ application: { ...this.state.application, [name]: value } });
    }

    deleteAttachment(attachment) {
        let files = [...this.props.applicationDetails.attachments];
        const index = files.indexOf(attachment);
        if (index >= 0) {
            this.setState({
                application: {
                    ...this.state.application,
                    deletedAttachments: [...this.state.application.deletedAttachments, attachment.documentId]
                }
            });
        }
    }

    save = async (bypass = false) => {
        if (this.state.error || this.state.manualCheckError) this.setState({ error: false, manualCheckError: false });

        const missingFields = this.props.getIncompleteFields(this.state.application, this.state.thirdPartyPayeeType);
        if (this.state.submitAttempted || !missingFields) {
            let application = { ...this.state.application };

            if (application.paymentInfo.manualPayment.manualPaymentType && application.amount) {
                application.amount = ''; //clear out amount if paid by manual check
            }
            else if (!application.paymentInfo.manualPayment.manualPaymentType) {
                application.paymentInfo.manualPayment = null;
            }

            await this.props.updateApplication(this.props.applicationDetails.applicationId, application, bypass);

            if (this.props.updateApplicationDetails.success) {

                const getUpdatedRecipient = (!missingFields && application.paymentInfo.manualPayment && application.paymentInfo.manualPayment.manualPaymentType) //need updated recipient total
                    || application.sourceId !== this.initialState.application.sourceId //need updated recipient references / trusted payee isUsedAsPayee
                    || !deepEquals(application.paymentInfo, this.initialState.application.paymentInfo);

                this.props.getApplicationDetails(this.props.applicationDetails.applicationId, true,
                    (getUpdatedRecipient ? this.props.applicationDetails.recipientId : null));

                this.props.getApplicationHistory();

                this.props.toggleEditMode();
            } else {
                if (this.props.updateApplicationDetails.message) {
                    if (this.props.updateApplicationDetails.message.toLowerCase().indexOf('check number assigned') >= 0) {
                        this.toggleModal("checkExistsWarningModal");
                    }
                    else if(this.props.updateApplicationDetails.message.toLowerCase().indexOf("available") >= 0) {
                    this.setState({
                        manualCheckError: true,
                        manualCheckLabel: '',
                        application: {
                            ...application,
                            paymentInfo: {
                                ...application.paymentInfo,
                                manualPayment: {
                                    ...application.paymentInfo.manualPayment,
                                    blankCheckId: ''
                                }
                            }
                        }
                    });
                }
                } else {
                    this.setState({ error: true });
                }
            }
        } else {
            if (!this.state.submitAttempted) this.setState({ submitAttempted: true });
        }
    }

    isWedding(reasonId, applicationReasons) {
        const s = "wedding";

        for (let index = 0; index < applicationReasons.length; index++) {
            const element = applicationReasons[index];
            if (element.key == reasonId)
            {
               let containsWedding = element.value.toLowerCase().includes(s);
                if (containsWedding)
                    return true;
            }
        }
        return false;
    }

    render() {
        const { application, applicationSourceType, manualCheckLabel, thirdPartyPayeeType, submitAttempted, error } = this.state;
        const { userId, permissions, blankChecks, applicationDetails, updateApplicationDetails, recipientDetails, tags, toggleEditMode } = this.props;

        const isManualPayment = application.paymentInfo.manualPayment && application.paymentInfo.manualPayment.manualPaymentType;

        const payeeIsIsraeli = getApplicationPayee(application.paymentInfo, recipientDetails).isIsraeli;

        const incompleteFields = this.props.getIncompleteFields(this.state.application, this.state.thirdPartyPayeeType);

        const isDisabled =
            deepEquals(this.initialState.application, this.state.application) //no changes
            || (applicationDetails.status === ApplicationStatuses.Approved && application.amount > applicationDetails.maxApprovalAmount)  //when amount is editable check that amount does not exceed max amount
            || (this.state.submitAttempted && !this.state.incomplete && incompleteFields) //cannot make complete app incomplete
            || !application.paymentInfo.fundId || !application.approverId; //these 2 fields cannot be removed even for incomplete
        
        const showMarkInquiry = application.approverId === userId || permissions.admin;

        const applicantPledgeOptions = recipientDetails.applicantPledges.map(
          (x) => {
            return {
              key: x.applicantPledgeId,
              value:
                formatDate(x.pledgeDate) +
                " - " +
                formatCurrency(x.pledgeAmount),
            };
          }
        );

        return (
            <div className="details-card card">
                <div className="details-card-header flex-justify flex-center">
                    <label className="input-label">Edit Details</label>
                </div>
                <div className="details-card-edit">
                    {applicationDetails.status === ApplicationStatuses.Incomplete &&
                        <div className="error-label">This application was incomplete</div>}
                    {applicationDetails.inquire &&
                        <MarkInquiryWarning
                            inquireNote={application.inquireNote}
                        />}

                    <div className="flex-center info-row">
                        {applicationDetails.status === ApplicationStatuses.Approved && !isManualPayment
                            && <div className="column-third">
                                <ValidatedInput
                                    input={<CurrencyFormatInput tabIndex={500} isIsraeli={payeeIsIsraeli} />}
                                    label="Amount"
                                    name="amount" value={application.amount}
                                    onChange={this.updateApplication}
                                    required={applicationDetails.status === ApplicationStatuses.Approved}
                                    showRequiredError={submitAttempted}
                                    validated={true}
                                    showValidationError={true}
                                    validate={val => applicationDetails.maxApprovalAmount ? stripCurrencyFormat(val) <= applicationDetails.maxApprovalAmount : true}
                                    errorMessage={`Amount cannot exceed ${formatCurrency(applicationDetails.maxApprovalAmount, payeeIsIsraeli)}.`} />
                            </div>}
                        {!applicationDetails.campaign && <div className={applicationDetails.status === ApplicationStatuses.Approved ? "column-third" : "column-half"}>
                            <label className="input-label">Request Amount</label>
                            <CurrencyFormatInput tabIndex={505}
                                name="requestAmount" value={application.requestAmount}
                                onChange={this.eventUpdate.bind(this, this.updateApplication)}
                                isIsraeli={payeeIsIsraeli} />
                        </div>}
                        <div className={applicationDetails.status === ApplicationStatuses.Approved ? "column-third" : "column-half"}>
                            {(!applicationDetails.campaign && permissions.applications.private) &&
                                <div className="custom-check-container">
                                    <input type="checkbox" id="check-private"
                                        className="custom-check" name="isPrivate"
                                        checked={application.isPrivate}
                                        onChange={this.eventUpdate.bind(this, this.updateApplication)} />
                                    <label htmlFor="check-private">Private</label>
                                </div>}
                        </div>
                    </div>
                    {!applicationDetails.campaign && <div className="flex-center">
                        <div className="column-half column-half-left">
                            <ValidatedInput input={<Select tabIndex={510}
                                clearable={true}
                                options={tags.applicationReasons} />}
                                onChange={this.updateApplication}
                                required={!isManualPayment} showRequiredError={submitAttempted}
                                label="Reason" name="reasonId" value={application.reasonId} />
                        </div>
                        <div className="column-half column-half-right">
                            <ValidatedInput input={<Select tabIndex={520} options={tags.approvers} />}
                                name="approverId" value={application.approverId}
                                onChange={this.updateApplication}
                                label="Approver" required={true}
                                showRequiredError={submitAttempted} />
                        </div>
                    </div>}
                    {
                        this.isWedding(application.reasonId, tags.applicationReasons)
                        &&
                        <div className="info-row flex-center">
                            <div className="column-quarter"> 
                                <ValidatedInput 
                                input={<input type="date" format="mm/dd/yyyy" min={formatDateForInput(application.reasonDate)} max="9999-12-31"/>}
                                label="Wedding Date" name="reasonDate" value={formatDateForInput(application.reasonDate)} tabIndex={432}
                                onChange={this.updateApplication}                         
                                required={false} showRequiredError={this.submitAttempted} />
                            </div>
                            <div className="column-quarter"> 
                                <ValidatedInput
                                input={<input type="text" />}
                                label="Wedding Hall"
                                name="weddingHall"
                                value={application.weddingHall}
                                onChange={this.updateApplication}
                            />
                            </div>
                            <div className="column-quarter"> 
                                <ValidatedInput 
                                    input={<Select tabIndex={430} options={[{ key: 'Boy', value: 'Boy'}, { key: 'Girl', value: 'Girl'}]} />}
                                    label="Side" name="weddingSide" value={application.weddingSide}
                                    onChange={this.updateApplication} 
                                />
                            </div>
                        </div>
                    }
                    <div className="info-row flex-center">
                        <RadioGroup
                            title="Source"
                            options={[
                                { key: 'new', value: 'Enter New' },
                                { key: 'reference', value: 'Choose Reference', disabled: !recipientDetails.references.length }
                            ]}
                            name="applicationSourceType" value={this.state.applicationSourceType}
                            onChange={this.onChange} />
                        {applicationSourceType === "reference"
                            ? <Select tabIndex={530}
                                options={recipientDetails.references.map(ref => ({ key: ref.referenceId, value: ref.displayName }))}
                                name="sourceId"
                                value={application.sourceId}
                                onChange={e => this.updateApplication(e.target.name, e.target.value)} />
                            : <AutocompleteInput tabIndex={530}
                                showList={true}
                                placeholder="Search references"
                                name="sourceId" value={application.sourceId}
                                options={formatReferenceOptions(tags.references
                                    .filter(r => recipientDetails.references.map(ref => ref.referenceId).indexOf(r.referenceId) < 0))}
                                update={this.updateApplication}
                            />}
                    </div>
                    <div className="info-row flex-center">
                        <div className="column-third">
                        <label className="input-label">Campaign Individual Category</label>
                        <Select tabIndex={450} clearable={true} 
                                options={tags.campaignIndivCategories}
                                name="individualCategoryId"
                                value={application.individualCategoryId}
                                onChange={e => this.updateApplication(e.target.name, e.target.value)} />
                        </div>
                        {recipientDetails.applicantPledges.length >= 1 && <div className="column-third">
                            <label className="input-label">Pledge</label>
                            <Select tabIndex={455} clearable={true} 
                                    options={applicantPledgeOptions}
                                    name="applicantPledgeId"
                                    value={application.applicantPledgeId}
                                    onChange={e => this.updateApplication(e.target.name, e.target.value)} />
                        </div>}
                    </div>
                    <div>
                        <div>
                            <PaymentInfo
                                applicationId={applicationDetails.applicationId}
                                campaignApplication={applicationDetails.campaign}
                                submitAttempted={submitAttempted}
                                paymentInfo={application.paymentInfo}
                                manageAccounting={permissions.accounting.manage}

                                payeeIsIsraeli={payeeIsIsraeli}
                                initialThirdParty={{
                                    referenceId: '',
                                    useRecipientAddress: false,
                                    isIsraeli: recipientDetails.isIsraeli,
                                    firstName: '',
                                    lastName: '',
                                    orgName: '',
                                    address: {},
                                    bankNumber: '',
                                    branchNumber: '',
                                    accountNumber: '',
                                    accountHolder: '',
                                    careOf: ''
                                }}
                                preEditThirdParty={this.initialState.application.paymentInfo.thirdParty}
                                trustedPayee={recipientDetails.trustedPayee}

                                onChange={this.onChange}
                                updateApplication={this.updateApplication}
                                updatePaymentInfo={this.updatePaymentInfo}

                                funds={(payeeIsIsraeli && !isManualPayment) ? tags.israeliFunds : tags.usFunds}
                                defaultUSFund={tags.defaultUSFund}
                                defaultIsraeliFund={tags.defaultIsraelFund}

                                blankChecks={{
                                    ...blankChecks,
                                    data: [
                                        ...(applicationDetails.paymentInfo && applicationDetails.paymentInfo.manualPayment 
                                            && applicationDetails.paymentInfo.manualPayment.manualPaymentType && applicationDetails.paymentInfo.manualPayment.blankCheckId
                                            && applicationDetails.paymentInfo.fundId.toString() === application.paymentInfo.fundId.toString())
                                            ? [{
                                                blankCheckId: applicationDetails.paymentInfo.manualPayment.blackCheckId,
                                                checkNumber: applicationDetails.paymentInfo.manualPayment.manualPaymentNumber
                                            }] : [],
                                        ...blankChecks.data
                                    ]
                                }}
                                getBlankChecks={this.props.getBlankChecks}
                                manualCheckLabel={manualCheckLabel}
                                manualPaymentTypes={this.props.manualPaymentTypes}

                                thirdPartyPayeeType={thirdPartyPayeeType}
                                showCareOf={this.state.showCareOf}
                                recipientReferences={recipientDetails.references.filter(ref => ref.isPayable)}
                                recipientAddress={(!recipientDetails.isIsraeli && recipientDetails.address) ? concatenateAddressLabel(recipientDetails.address) : ''}
                                recipientTypes={tags.recipientTypes} />
                        </div>

                        <div>
                            <div className="info-row">
                                <div className="column-third">
                                    <label className="input-label"><i className="icon ion-paperclip icon-left xl-text middle" />
                                        Attachment(s):</label>
                                    {applicationDetails.attachments && applicationDetails.attachments.map((attachment, index) => {
                                        if ((this.state.application.deletedAttachments.indexOf(attachment.documentId)) < 0)
                                            return <p className="small-text" key={index}><i
                                                className="icon ion-document icon-left middle" />{attachment.name}
                                                <i onClick={this.deleteAttachment.bind(this, attachment)}
                                                    className="icon ion-trash-b trash-hover accent-text icon-right" /></p>;
                                        return null;
                                    })}
                                </div>

                                <UploadAttachments files={application.newAttachments} name="newAttachments"
                                    onChange={this.updateAttachments.bind(this)} />

                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: "24px" }}>
                        <p className="medium-text">Print Instructions</p>
                        <br />
                        <div className="info-row">
                            <div className="column-third">
                                <label className="input-label">Card Type</label>
                                <Select tabIndex={800}
                                    clearable={true} name="cardTypeId" value={application.cardTypeId}
                                    options={tags.cardTypes}
                                    onChange={this.eventUpdate.bind(this, this.updateApplication)} />
                            </div>
                            <div className="column-two-thirds">
                                <label className="empty-label" />
                                <input tabIndex={810}
                                    type="text" placeholder="Enter any other instructions"
                                    name="printInstructions" value={application.printInstructions}
                                    onChange={this.eventUpdate.bind(this, this.updateApplication)} />
                            </div>
                        </div>
                    </div>

                    {showMarkInquiry &&
                        <MarkInquiry inquire={application.inquire}
                            inquireNote={application.inquireNote}
                            updateApplication={this.updateApplication}/>}

                    {(submitAttempted && incompleteFields) &&
                        <IncompleteApplicationWarning
                            fields={incompleteFields}
                            allowIncomplete={applicationDetails.status === ApplicationStatuses.Incomplete}/>}

                <CheckExistsWarningModal
                    transactions={this.props.updateApplicationDetails.data}
                    message={this.props.updateApplicationDetails.message}
                    show={this.state.showModals.checkExistsWarningModal}
                    close={() => this.toggleModal("checkExistsWarningModal")}
                    continue={() => this.save(true)} />

                    {updateApplicationDetails.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                        <div className="details-card-footer clearfix text-right">
                            <button className="btn btn-accent" onClick={toggleEditMode}>Cancel</button>
                            <button className="btn btn-flat btn-flat-primary" onClick={this.save.bind(this)}
                                disabled={isDisabled}>
                                <i className="material-icons icon-left">save</i>Update
                            </button>
                            <FadeOutErrorMessage show={error || this.state.manualCheckError}
                                message={this.state.manualCheckError ? 'Manual Check Number is not available. Please select a different check number.' : 'Something went wrong and the application could not be updated. Please try again.'} />
                        </div>}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/ApplicationDetailsEditCard.jsx